import { DictionariesByLocale, getLocaleStringFromLocale } from '@lib-helpers'
import { ComponentTranslationProvider, DictionaryProvider } from '@lib-components'
import { use, ReactElement } from 'react'
import { LocaleContext } from '@/providers/locale-provider'

interface DictionaryProviderWrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    dictionariesByLocale: DictionariesByLocale
}

export const DictionaryProviderWrapper = ({
    dictionariesByLocale,
    children,
}: DictionaryProviderWrapperProps): ReactElement => {
    const { activeLocale } = use(LocaleContext)

    return (
        <DictionaryProvider dictionary={dictionariesByLocale[getLocaleStringFromLocale(activeLocale)] ?? {}}>
            <ComponentTranslationProvider
                dictionary={dictionariesByLocale[getLocaleStringFromLocale(activeLocale)] ?? {}}
            >
                {children}
            </ComponentTranslationProvider>
        </DictionaryProvider>
    )
}
